// extracted by mini-css-extract-plugin
module.exports = {"optionText":"RootFolderSelectInputOption-optionText-19Afw","isMobile":"RootFolderSelectInputOption-isMobile-MThqn","freeSpace":"RootFolderSelectInputOption-freeSpace-gkGJP"};